export function vanishElement (element, hidden = true) {
  element.classList.toggle("invisible", hidden);
  element.classList.toggle("h-0", hidden);
}
